import permissionProvider from "@data-access/permission";

export default {
  state: {
    listPermission: [],
    totalElements: 0,
    listAllPermission: [],
  },
  reducers: {
    updateData(state, payload = {}) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    getData: (payload, state) => {
      permissionProvider.search(payload).then((res) => {
        if (res && res.code === 0 && res.data) {
          dispatch.permission.updateData({
            listPermission: res.data,
            totalElements: res.totalElements,
          });
        }
      });
    },
    getAll: (payload, state) => {
      permissionProvider
        .search({ ...payload, page: 0, size: 999999 })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            dispatch.permission.updateData({
              listAllPermission: res.data,
            });
          }
        });
    },
  }),
};
